export const openDownload = (url: string) => {
  window.location.assign(url);
};

export const downloadFile = (blobData: Blob | string, filename: string) => {
  const blob = new Blob([blobData], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  if (link.download !== undefined) {
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const saveToFile = (blob: Blob, name: string, fileType: string) => {
  const url = window.URL.createObjectURL(blob);
  let a = document.createElement("a");
  a.href = url;
  a.download = `${name}.${fileType}`;
  a.click();
};
